/** What a sessionDisconnected event calls for, given who this client is. */
export type SessionDisconnectHandling = 'kick' | 'rejoin' | 'notify-error' | 'none';

/** How long the equipment waits between two attempts to re-enter the conference. */
export const EQUIPMENT_REJOIN_DELAY_MS = 5_000;

/** 'networkDisconnected' means the SDK gave up reconnecting. The unattended equipment must rejoin
 * by itself: it alone reports the audio-device presence facts. */
export function sessionDisconnectHandling(reason: string, isEquipment: boolean): SessionDisconnectHandling {
  if (reason === 'forceDisconnected') {
    return 'kick';
  }
  if (reason !== 'networkDisconnected') {
    return 'none';
  }
  return isEquipment ? 'rejoin' : 'notify-error';
}
